<template>
  <GeneralTheme :theme="configuration">
    <section
      :class="{
        'media-two-column-component': true,
      }"
    >
      <div
        :class="{
          'container mx-auto px-0': !fullWidthContent,
        }"
      >
        <div
          :class="{
            'grid grid-cols-12 lg:gap-30px': true,
            [verticalAlignment === 'top' ? 'items-start' : 'items-center']: true,
          }"
        >
          <div :class="primaryColumnClasses">
            <ParallaxTheme :theme="primaryBlockTheme">
              <PrimaryBlock
                v-if="mediaTwoColumn && mediaTwoColumn.primaryBlock"
                v-bind="mediaTwoColumn.primaryBlock"
                :class="{
                  'w-full': true,
                }"
              />
            </ParallaxTheme>
          </div>
          <div :class="secondaryColumnClasses">
            <ParallaxTheme :theme="secondaryBlockTheme">
              <SecondaryBlock
                v-if="mediaTwoColumn && mediaTwoColumn.secondaryBlock"
                v-bind="mediaTwoColumn.secondaryBlock"
                :class="{
                  'w-full': true,
                }"
              />
            </ParallaxTheme>
          </div>
        </div>
      </div>
    </section>
  </GeneralTheme>
</template>

<script setup lang="ts">
import type { MediaTwoColumnPrimaryBlock, SectionBuilderMediaTwoColumn } from '~/sanity/types';
const props = defineProps<SectionBuilderMediaTwoColumn>();
const { primaryBlockTheme, secondaryBlockTheme } = props;

type WidthType = NonNullable<MediaTwoColumnPrimaryBlock['width']>;

//Initialize widths dynamically based on props or logic
const primaryWidth = ref<WidthType>(props.mediaTwoColumn?.primaryBlock?.width || '6'); // Fallback to default if no width is provided
const primaryAlignment = ref<string>(props.mediaTwoColumn?.primaryBlock?.alignment || 'left'); // Fallback to default if no width is provided
const secondaryWidth = computed(() => 12 - Number(primaryWidth.value)); // Dynamically calculate secondary width

const primaryColumnClasses = computed(() => ({
  [widthStyles[primaryWidth.value]]: true,
  [alignmentStyles[primaryAlignment.value]]: true,
  'content-center col-span-12': true,
}));
const secondaryColumnClasses = computed(() => ({
  [widthStyles[secondaryWidth.value]]: true,
  [alignmentSecodaryStyles[primaryAlignment.value]]: true,
  'content-center col-span-12': true,
}));

const widthStyles: Record<string, string> = {
  '1': ' lg:col-span-1',
  '2': ' lg:col-span-2',
  '3': ' lg:col-span-3',
  '4': ' lg:col-span-4',
  '5': ' lg:col-span-5',
  '6': ' lg:col-span-6',
  '7': ' lg:col-span-7',
  '8': ' lg:col-span-8',
  '9': ' lg:col-span-9',
  '10': ' lg:col-span-10',
  '11': ' lg:col-span-11',
};

const alignmentStyles: Record<string, string> = {
  left: 'lg:order-0',
  right: 'lg:order-1',
};
const alignmentSecodaryStyles: Record<string, string> = {
  left: 'lg:order-1',
  right: 'lg:order-0',
};
</script>
<style lang="scss">
.media-two-column-component {
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr; /* example */
    align-items: stretch; /* ensures children take full height */
  }
  .grid > div {
    display: flex !important; /* or grid, doesn't matter */
  }

  .grid img {
    width: 100%;
    height: 100% !important;
    object-fit: cover !important; /* keep aspect ratio & crop */
  }
}
</style>
